import React from "react";
import { MDBBadge, MDBIcon } from "mdb-react-ui-kit";
import UserSearchPicker from "../UserSearchPicker/UserSearchPicker";
import "./ParticipationEditor.css";

/**
 * Editor de participaciones de usuarios en una cuenta o transacción.
 *
 * Props:
 *   participaciones  {Array}    [{tipo, IDUsuario?, IDUsuarioCCON?, nombre, participacion}]
 *   usuariosCCON     {Array}    Lista completa de usuarios CCON del usuario actual
 *   onChange         {Function} Callback (participaciones) => {}
 *   allowSearch      {boolean}  Mostrar buscador para añadir más usuarios (default true)
 */
class ParticipationEditor extends React.Component {
  handleParticipacionChange(index, value) {
    const raw = value.replace(/[^0-9.]/g, "");
    const participaciones = [...this.props.participaciones];
    participaciones[index] = {
      ...participaciones[index],
      participacion: raw === "" ? "" : parseFloat(raw),
    };
    this.props.onChange(participaciones);
  }

  handleRemove(index) {
    const participaciones = this.props.participaciones.filter(
      (_, i) => i !== index
    );
    this.props.onChange(participaciones);
  }

  handleAddUser(user) {
    const { participaciones } = this.props;

    // Evitar duplicados
    const isDuplicate =
      user.tipo === "SSO"
        ? participaciones.some((p) => p.tipo === "SSO" && p.IDUsuario === user.IDUsuario)
        : participaciones.some(
            (p) => p.tipo === "CCON" && p.IDUsuarioCCON === user.IDUsuarioCCON
          );

    if (isDuplicate) return;

    const nuevaParticipacion = { ...user, participacion: 100 };
    this.props.onChange([...participaciones, nuevaParticipacion]);
  }

  render() {
    const {
      participaciones = [],
      usuariosCCON = [],
      allowSearch = true,
    } = this.props;

    const excludeIds = participaciones
      .filter((p) => p.tipo === "SSO")
      .map((p) => p.IDUsuario);
    const excludeCCONIds = participaciones
      .filter((p) => p.tipo === "CCON")
      .map((p) => p.IDUsuarioCCON);

    return (
      <div className="participation-editor">
        {participaciones.length > 0 && (
          <table className="participation-table">
            <thead>
              <tr>
                <th>Usuario</th>
                <th>% Participación</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {participaciones.map((p, index) => (
                <tr key={index}>
                  <td>
                    <MDBBadge
                      color={p.tipo === "SSO" ? "primary" : "secondary"}
                      pill
                      light
                      className="me-2"
                    >
                      {p.tipo === "SSO" ? "SSO" : "Ext"}
                    </MDBBadge>
                    {p.nombre}
                    {p.email && (
                      <span className="participation-email"> ({p.email})</span>
                    )}
                  </td>
                  <td>
                    <input
                      type="number"
                      min="0"
                      max="100"
                      step="1"
                      className="participation-input"
                      value={p.participacion}
                      onChange={(e) =>
                        this.handleParticipacionChange(index, e.target.value)
                      }
                    />
                    <span className="participation-pct">%</span>
                  </td>
                  <td>
                    {participaciones.length > 1 && (
                      <button
                        type="button"
                        className="participation-remove"
                        title="Eliminar"
                        onClick={() => this.handleRemove(index)}
                      >
                        <MDBIcon icon="times" />
                      </button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}

        {allowSearch && (
          <UserSearchPicker
            usuariosCCON={usuariosCCON}
            excludeIds={excludeIds}
            excludeCCONIds={excludeCCONIds}
            onSelect={(user) => this.handleAddUser(user)}
          />
        )}
      </div>
    );
  }
}

export default ParticipationEditor;
